export const ALLOY_KEY_PREFIX = 'alloy-swr-';

export const baseParser = (value: string | null) =>
  value === 'undefined' || value === null ? undefined : JSON.parse(value);

export const setDataInStorage = <T>(data: T, key: string) => {
  try {
    sessionStorage.setItem(`${ALLOY_KEY_PREFIX}${key}`, JSON.stringify(data));
  } catch {
    // Ignore till we find a better way to handle it
  }
};
